export const CREATE_MCP_FORM_ID = 'create-mcp-token-form';

export const CREATE_MCP_MODAL_TEST_ID = 'developers_mcp_create-modal';
export const CREATE_MCP_NAME_TEST_ID = 'developers_mcp_create_name-input';
export const CREATE_MCP_NAME_ERROR_TEST_ID = 'developers_mcp_create_name-error';
export const CREATE_MCP_SUBMIT_TEST_ID = 'developers_mcp_create_submit-btn';
export const CREATE_MCP_CANCEL_TEST_ID = 'developers_mcp_create_cancel-btn';
export const CREATE_MCP_ERROR_TEST_ID = 'developers_mcp_create_request-error';

export const CREATE_MCP_REVEAL_TEST_ID = 'developers_mcp_reveal';
export const CREATE_MCP_REVEAL_TOKEN_TEST_ID =
  'developers_mcp_reveal_token-label';
export const CREATE_MCP_REVEAL_COPY_TEST_ID = 'developers_mcp_reveal_copy-btn';
export const CREATE_MCP_REVEAL_DONE_TEST_ID = 'developers_mcp_reveal_done-btn';

export const CREATE_MCP_TITLE = 'Create MCP token';
export const CREATE_MCP_NAME_LABEL = 'Name';
export const CREATE_MCP_NAME_PLACEHOLDER = 'e.g. My AI assistant';
export const CREATE_MCP_SUBMIT_LABEL = 'Create token';
export const CREATE_MCP_CANCEL_LABEL = 'Cancel';

export const CREATE_MCP_REVEAL_TITLE = 'MCP token created';
export const CREATE_MCP_REVEAL_TOKEN_LABEL = 'MCP token';
export const CREATE_MCP_REVEAL_WARNING =
  "Copy your MCP token now — you won't be able to see it again.";
export const CREATE_MCP_REVEAL_DONE_LABEL = 'Done';

export const CREATE_MCP_GENERIC_ERROR =
  'Something went wrong creating your MCP token.';
export const CREATE_MCP_RECOVERY_COPY =
  'If a token was still created, it will appear in the list after a refresh — revoke it there before trying again.';
